type VariablesListProps = {
  variables: Array<{ name: string; description: string }>
  customFields?: Array<{ id: string; name: string; description: string }>
}

export const VariablesList = ({ variables, customFields }: VariablesListProps) => (
  <div className="mt-2">
    <strong>Verfügbare Variablen:</strong>
    <ul className="list-inside list-disc text-sm">
      {variables.map((variable) => (
        <li key={variable.name}>
          {variable.name} - {variable.description}
        </li>
      ))}
      {customFields?.map((field) => (
        <li key={field.id}>
          {`{{${field.name}}}`} - Benutzerdefiniertes Feld: {field.description}
        </li>
      ))}
    </ul>
  </div>
)
